import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/whatsapp";

export const WhatsAppFloat = () => (
  <motion.a
    href={waLink()}
    target="_blank"
    rel="noopener noreferrer"
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 1.2, duration: 0.6 }}
    className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-teal-dark text-cream px-4 py-3.5 rounded-full shadow-[0_12px_32px_rgba(13,59,57,0.35)] hover:bg-teal transition-colors duration-300 group"
    data-testid="whatsapp-float-button"
  >
    <MessageCircle size={20} />
    <span className="hidden sm:inline font-mono text-xs uppercase tracking-[0.1em] max-w-0 overflow-hidden group-hover:max-w-xs transition-all duration-500 whitespace-nowrap">
      Falar no WhatsApp
    </span>
  </motion.a>
);
